import { cdsBroadcastChannel } from "utils"
import * as types from "../types/order"

const initialState = {
  tableNumber: "",
  items: [],
  combos: []
}

const sendToCds = (items) => {
  const bc = cdsBroadcastChannel?.get()

  if (!bc) return

  bc.postMessage({
    type: "checkoutChanges",
    orderItems: items
  })
}

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REPLACE_ORDER: {
      sendToCds(action.newOrder.items)

      return { ...action.newOrder }
    }
    case types.ADD_ORDER_ITEMS: {
      const newOrderItems =
        action.newOrderItems.map(oi => ({
          sortNumber: new Date().getTime(),
          ...oi
        }))

      const newItems =
        [...state.items, ...newOrderItems]

      sendToCds(newItems)

      return { ...state, items: newItems }
    }
    case types.ADD_ORDER_ITEM: {
      action.newOrderItem["sortNumber"] = new Date().getTime()

      const newItems =
        [...state.items, action.newOrderItem]

      sendToCds(newItems)

      return { ...state, items: newItems }
    }
    case types.UPDATE_ORDER_ITEM: {
      const newItems =
        state.items.map(item =>
          item.orderItemId === action.orderItemId
            ?
            {
              ...item,
              ...action.orderItem
            }
            :
            item
        )

      sendToCds(newItems)

      return { ...state, items: newItems }
    }
    case types.DELETE_ORDER_ITEM: {
      const newItems =
        state.items.filter(item =>
          item.orderItemId !== action.orderItemId
        )

      sendToCds(newItems)

      return { ...state, items: newItems }
    }
    case types.SET_ORDER_TABLE_NUMBER:
      return {
        ...state,
        tableNumber: action.tableNumber
      }
    case types.CLEAR_ORDER_TABLE_NUMBER:
      return { ...state, tableNumber: "" }
    case types.DELETE_ALL_ORDER_ITEMS: {
      sendToCds([])

      return { ...state, items: [], combos: [] }
    }
    case types.ADD_COMBO_TO_ORDER:
      action.newCombo["sortNumber"] = new Date().getTime()

      return {
        ...state,
        combos: [...state.combos, action.newCombo]
      }
    case types.EDIT_COMBO_TO_ORDER:
      return {
        ...state,
        combos:
          state.combos.map((combo, comboIndex) =>
            comboIndex === action.comboIndex
              ?
              {
                ...combo,
                ...action.editedCombo
              }
              :
              combo
          )
      }
    case types.DELETE_COMBO_FROM_ORDER:
      return {
        ...state,
        combos:
          state.combos.filter((_, cIndex) =>
            cIndex !== action.comboIndex
          )
      }
    case types.CONVERT_ORDER_ITEMS_TO_BUY_X_FREE_X: {
      const filteredOrderItems =
        state.items.filter(orderItem =>
          !action.removeOrderItemIds[orderItem.orderItemId]
        )

      const newItems =
        filteredOrderItems.map(orderItem =>
          !!action.updateOrderItemsIds[orderItem.orderItemId]
            ?
            {
              ...orderItem,
              quantity: action.updateOrderItemsIds[orderItem.orderItemId]
            }
            :
            orderItem
        )

      action.newCombo["sortNumber"] =
        new Date().getTime()

      return {
        ...state,
        items: newItems,
        combos: [...state.combos, action.newCombo]
      }
    }
    default:
      return state
  }
}

export default ordersReducer